import { useEffect } from 'react'

import { useMap } from '@vis.gl/react-google-maps'

import type { TLote } from '@/features/empreendimentos/http'
import type { Coordinate } from '@/types/blocos'

import { LoteMarker } from './lote-marker'

export interface MapContentProps {
  overlayCoordinates: [Coordinate, Coordinate]
  imageUri: string
  lotes: TLote[]
  onLotePress?: (lote: TLote) => void
}

export const MapContent = ({ overlayCoordinates, imageUri, lotes, onLotePress }: MapContentProps) => {
  const map = useMap()

  useEffect(() => {
    if (!map) return

    const [northWest, southEast] = overlayCoordinates
    const imageBounds = {
      north: northWest.latitude,
      south: southEast.latitude,
      east: southEast.longitude,
      west: northWest.longitude,
    }

    const overlay = new google.maps.GroundOverlay(imageUri, imageBounds)
    overlay.setMap(map)

    return () => {
      overlay.setMap(null)
    }
  }, [map, overlayCoordinates, imageUri])

  return (
    <>
      {lotes.map((lote) => {
        if (!lote.coordenadas || lote.coordenadas.length === 0) return null
        return (
          <LoteMarker
            key={lote.id}
            lote={lote}
            onClick={() => {
              onLotePress?.(lote)
            }}
          />
        )
      })}
    </>
  )
}
